import script from "./VysledkyDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./VysledkyDetail.vue?vue&type=script&setup=true&lang=ts"

import "./VysledkyDetail.vue?vue&type=style&index=0&id=1314f148&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1314f148"]])

export default __exports__